// src/components/games/GamePurchaseBox.jsx
import { FaShoppingBag } from 'react-icons/fa';

export default function GamePurchaseBox({
  gameName = '',
  price = 0,
  discountRate = 0,
  backgroundImage = '',
  comingSoon = false,
  purchaseLink = '',
  tags = [], // 태그 배열을 받습니다
}) {

  const numericPrice = Number(price) || 0;
  const numericDiscount = Math.min(Math.max(Number(discountRate) || 0, 0), 100);
  const discountedPrice = Math.round(
    numericPrice * (100 - numericDiscount) / 100
  );

  // "게임잼" 단어가 포함된 태그가 하나라도 있으면 true
  const hasGameJamTag = tags.some(tag => tag.includes('게임잼'));

  let priceInfo;
  if (numericPrice === 0 && numericDiscount === 0) {
    priceInfo = comingSoon ? (
      <span className="text-yellow-300 text-2xl font-bold">출시예정</span>
    ) : (
      <span className="text-green-400 text-2xl font-bold">무료</span>
    );
  } else {
    priceInfo = (
      <div className="flex items-center space-x-2">
        {numericDiscount > 0 && (
          <>
            <span className="text-red-400 text-sm font-bold">
              -{numericDiscount}%
            </span>
            <span className="line-through text-gray-500 text-2xl">
              ₩{numericPrice.toLocaleString()}
            </span>
          </>
        )}
        <span className="text-white text-2xl font-bold">
          ₩{discountedPrice.toLocaleString()}
        </span>
      </div>
    );
  }

  const handlePurchaseClick = () => {
    if (purchaseLink) {
      window.open(purchaseLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className="relative w-full bg-cover bg-center rounded-xl overflow-hidden"
      style={{
        minHeight: '240px',
        backgroundImage: `url('${backgroundImage}')`,
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-neutral-800 to-transparent" />

      <div className="absolute inset-x-0 bottom-0 px-6 pb-4 flex flex-col space-y-2 z-10">
        <div className="flex items-center pb-2">
          <p className="text-white text-2xl font-bold">{gameName}</p>
          <span className="ml-2 text-white text-2xl font-bold">구매</span>
        </div>

        <div className="flex items-center justify-end space-x-4">
          {priceInfo}

          {/* tags 배열 중에 "게임잼"이 포함된 태그가 없을 때만 구매 버튼 표시 */}
          {!hasGameJamTag && (
            <button
              type="button"
              onClick={handlePurchaseClick}
              className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-2 rounded flex items-center gap-2 whitespace-nowrap"
            >
              <FaShoppingBag />
              구매하기
            </button>
          )}

        </div>
      </div>
    </div>
  );
}
